// Copyright (c) 2026 Goffy. All Rights Reserved.

/**
 * Merit boost: a percentage a round applies on top of every game's own weight when it pays
 * merits, so a final round can pay 150% without re-weighting its games one by one. The server
 * owns the arithmetic (Goffy.Scoring MeritBoost) and the merit ladders arrive already boosted;
 * the client only offers the setting.
 */

/** No boost — the round pays each game at its own weight. */
export const MERIT_BOOST_NONE = 100;

/** The most a round may boost; mirrors tour-service's MeritBoost.MaxPercent. */
export const MERIT_BOOST_MAX = 200;

/** The choices the round settings editor offers. */
export const MERIT_BOOST_OPTIONS: readonly number[] = [100, 125, 150, 200];

export function isValidMeritBoostPercent(value: unknown): value is number {
  return (
    typeof value === 'number'
    && Number.isInteger(value)
    && value >= MERIT_BOOST_NONE
    && value <= MERIT_BOOST_MAX
  );
}
